import { useState } from "react";

import { LinkedRegistries } from "./linked-registries/linked-registries";

export const RegistryTab = () => {
  const [openForm, setOpenForm] = useState(false);
  return <LinkedRegistries openForm={openForm} setOpenForm={setOpenForm} />;
};
